import React from 'react';
import { Link } from 'react-router-dom';
import Icon from '../../../components/AppIcon';
import Image from '../../../components/AppImage';
import Button from '../../../components/ui/Button';

const ServiceListItem = ({ service, onRequestQuote }) => {
  const handleRequestQuote = (e) => {
    e?.preventDefault();
    e?.stopPropagation();
    onRequestQuote(service);
  };

  return (
    <div className="bg-card border border-border rounded-lg shadow-subtle hover:shadow-moderate transition-all duration-300 p-6">
      <div className="flex flex-col lg:flex-row gap-6">
        {/* Service Image */}
        <div className="lg:w-48 lg:flex-shrink-0">
          <div className="relative overflow-hidden rounded-lg">
            <Image
              src={service?.image}
              alt={service?.title}
              className="w-full h-32 lg:h-32 object-cover"
            />
            <div className="absolute top-2 right-2 flex flex-col gap-1">
              {service?.isPopular && (
                <span className="inline-flex items-center px-2 py-1 rounded-full text-xs font-medium bg-accent text-accent-foreground">
                  <Icon name="Star" size={10} className="mr-1" />
                  Popular
                </span>
              )}
              {service?.isNew && (
                <span className="inline-flex items-center px-2 py-1 rounded-full text-xs font-medium bg-success text-success-foreground">
                  New
                </span>
              )}
            </div>
          </div>
        </div>

        {/* Service Details */}
        <div className="flex-1">
          <div className="flex flex-col lg:flex-row lg:items-start justify-between gap-4">
            <div className="flex-1">
              <div className="flex items-start justify-between mb-2">
                <div>
                  <h3 className="text-xl font-semibold text-foreground mb-2 hover:text-primary transition-colors">
                    {service?.title}
                  </h3>
                  <span className="inline-flex items-center px-2 py-1 rounded-full text-xs font-medium bg-muted text-muted-foreground">
                    {service?.category}
                  </span>
                </div>
              </div>

              <p className="text-muted-foreground mb-4 line-clamp-2">
                {service?.description}
              </p>

              <div className="flex flex-wrap items-center gap-4 text-sm text-muted-foreground mb-4">
                <div className="flex items-center space-x-1">
                  <Icon name="Clock" size={14} />
                  <span>{service?.timeline}</span>
                </div>
                <div className="flex items-center space-x-1">
                  <Icon name="Users" size={14} />
                  <span>{service?.teamSize}</span>
                </div>
                <div className="flex items-center space-x-1">
                  <Icon name="Star" size={14} className="text-accent" />
                  <span>{service?.rating}</span>
                  <span>({service?.reviews} reviews)</span>
                </div>
              </div>
            </div>

            {/* Price and Actions */}
            <div className="lg:text-right lg:min-w-[200px]">
              <div className="mb-4">
                <p className="text-sm text-muted-foreground">Starting from</p>
                <p className="text-xl font-semibold text-foreground">
                  {service?.priceRange}
                </p>
              </div>

              <div className="flex lg:flex-col gap-2">
                <Link to={`/service-details?id=${service?.id}`} className="flex-1 lg:flex-none">
                  <Button variant="outline" className="w-full">
                    <Icon name="Info" size={16} className="mr-2" />
                    Learn More
                  </Button>
                </Link>
                <Button
                  variant="default"
                  onClick={handleRequestQuote}
                  className="flex-1 lg:flex-none"
                >
                  <Icon name="FileText" size={16} className="mr-2" />
                  Request Quote
                </Button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ServiceListItem;